// Let controls, overflowing text and browser zoom keep their native gestures.
export function canStartSwipe(target, container, scale = 1) {
  if (!container || !target || scale > 1.01) return false;
  const element = target.nodeType === 1 ? target : target.parentElement;
  if (!element || !container.contains(element)) return false;
  // The video stage is a large tap-to-play surface, not a scrubber. A
  // vertical gesture there should still navigate; its control bar must not.
  const control = element.closest('a, button, input, textarea, select, [role="slider"], [role="button"], [contenteditable="true"], [data-no-swipe]');
  if (control && !control.matches('.recorded-media__video-toggle')) return false;

  for (let node = element; node && node !== container; node = node.parentElement) {
    if (/(auto|scroll)/.test(window.getComputedStyle(node).overflowY) && node.scrollHeight > node.clientHeight + 1) return false;
  }
  return true;
}

export function getSwipeDirection(start, end, threshold = null) {
  const elapsed = end.time - start.time;
  const distance = Math.abs(start.y - end.y);
  // Short, intentional flicks work without turning small taps into swipes.
  const minimum = threshold ?? (elapsed > 0 && elapsed < 250 && distance / elapsed >= 0.35 ? 24 : 45);
  const vertical = start.y - end.y;
  const horizontal = start.x - end.x;
  if (Math.abs(vertical) <= minimum || Math.abs(vertical) <= Math.abs(horizontal) * 1.25) return null;
  return vertical > 0 ? 'up' : 'down';
}
